import { createStyles } from "antd-style";

const useCustomAntStyles = createStyles(({ token, prefixCls, css }) => {
  const dashed = `${prefixCls}-btn-variant-dashed`;

  return {
    wrapper: css`
      height: 100dvh !important;
      overflow-y: auto;

      /* background: var(--Data-Display-Tabs-colorTabBg, #f5f5f5); */
      background: linear-gradient(
        180deg,
        #fff 0%,
        #fff 44px,
        var(--Data-Display-Tabs-colorTabBg, #f5f5f5) 44px,
        var(--Data-Display-Tabs-colorTabBg, #f5f5f5) 100%
      );

      .${dashed} {
        border-style: dashed;
        border-width: 2px;
        border-color: ${token.colorPrimary};
        color: ${token.colorPrimary};
        background: transparent;
        overflow: hidden;

        &:hover {
          background: var(--General-Button-dashedHoverBg, #e6f4ff);
        }

        &.${prefixCls}-btn-disabled {
          border-color: ${token.colorBorder};
          color: ${token.colorTextDisabled};
        }
      }
    `,

    content: css`
      width: 100%;
      max-width: 390px;
      height: 100%;
    `,
  };
});
export default useCustomAntStyles;
